interface ValidationRules {
  required ?: boolean
}

const constructValidationRules = ({required}: ValidationRules, t: Function) => {
  let validationRules = [];

  if (required) {
    validationRules.push({
      required: true,
      message: t('validation.field_required'),
    });
  }

  return validationRules;
}

export { constructValidationRules };
